var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgErrorLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 887,
    height: 700,
    viewBox: "0 0 887 700",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: -99,
    width: 632,
    height: 927
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.295 181.856C423.759 261.246 319.361 421.266 314.067 426.234L367.39 760.268L730.456 828L886.767 -9.88235L521.106 -63.7053L475.295 181.856Z",
    fill: "#FB8888"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: -91,
    width: 737,
    height: 786
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.79,
    y: -90.4727,
    width: 621.568,
    height: 683.041,
    transform: "rotate(10.5673 164.79 -90.4727)",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.175 -81.3383L280.649 -57.1845L530.39 414.315L604.021 19.6257L776.353 20.6394L650.553 694.974L503.343 667.512L267.706 218.79L194.736 609.939L28.0164 578.837L151.175 -81.3383Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -92,
    y: -99,
    width: 484,
    height: 853
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.33 489.93C313.434 402.435 386.714 225.983 391.008 220.129L277.33 -98.4614L-92 -98.4614L-91.9999 753.877L277.33 739.728L277.33 489.93Z",
    fill: "#FB8888"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 1,
    width: 623,
    height: 684
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.8254,
    y: 1.55371,
    width: 621.568,
    height: 683.041,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.116 13.029H155.823L487.797 430.732V29.233L657.393 -1.37451V684.594H507.644L193.712 286.696V684.594H24.116V13.029Z",
    fill: "white"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgErrorLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/errorLogo.35414161.svg";
export { ForwardRef as ReactComponent };